export default __webpack_public_path__ + "static/media/five.88ba0297.jpeg";